import { Bell, LogOut } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import { useTheme } from '../../context/ThemeContext';
import { getThemeClasses } from '../../utils/theme';
import ArgusLogo from '../common/ArgusLogo';

const Navbar = () => {
  const { user, logout } = useAuth();
  const { isDarkMode } = useTheme();
  const theme = getThemeClasses(isDarkMode);

  return (
    <nav className={`${theme.bgSecondary} border-b ${theme.border} sticky top-0 z-50`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <ArgusLogo size="md" />

          <div className="flex items-center gap-4">
            <button className={`relative p-2 ${theme.textTertiary} ${theme.bgHover} rounded-lg transition`}>
              <Bell className="w-5 h-5" />
              <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full" />
            </button>
            <div className={`flex items-center gap-3 pl-4 border-l ${theme.border}`}>
              <div className="text-right">
                <p className={`text-sm font-medium ${theme.textPrimary}`}>
                  {user?.name}
                </p>
                <p className={`text-xs ${theme.textTertiary}`}>
                  {user?.role}
                </p>
              </div>
              <button
                onClick={logout}
                className={`p-2 ${theme.textTertiary} ${theme.bgHover} rounded-lg transition`}
                title="Sign Out"
              >
                <LogOut className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
